
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M32.944 18.451h-7.698V21.6h7.698zM32.944 23.697h-7.698v3.148h7.698zM32.944 28.943h-7.698v3.147h7.698zM23.145 18.451h-7.698V21.6h7.698zM23.145 23.697h-7.698v3.148h7.698zM23.145 28.943h-7.698v3.147h7.698zM32.944 13.14h-7.698v3.148h7.698zM23.145 13.14h-7.698v3.148h7.698zM42.865 18.451h-7.698V21.6h7.698zM42.865 23.697h-7.698v3.148h7.698zM42.865 28.943h-7.698v3.147h7.698zM42.865 13.14h-7.698v3.148h7.698z"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M24.424 28.62c0 6.302-5.109 11.411-11.41 11.411S1.602 34.923 1.602 28.621s5.109-11.41 11.41-11.41 11.41 5.108 11.41 11.41"}}),_c('path',{attrs:{"stroke":"#234652","d":"M11.436 14.93V4.646H47.14V36.42H24.194M15.391 8.478h7.844M25.322 8.478h7.843M35.162 8.478h7.843M13.102 19.839v2.116M13.102 35.493v2.116M9.607 32.105a3.356 3.356 0 1 0 6.026-2.285c-1.129-1.5-2.777-1.027-4.399-2.226-.418-.36-.892-.898-1.067-1.421a3.07 3.07 0 1 1 5.889-1.723"}})])
          )
        }
      }
    